var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4224 16.3138C26.3747 16.3674 26.3151 16.4091 26.2495 16.433C26.184 16.4628 26.1124 16.4747 26.0409 16.4747H12.5416C12.0648 16.4747 11.8204 15.8787 12.1542 15.5211L14.3713 13.1669C14.419 13.1132 14.4786 13.0715 14.5501 13.0417C14.6156 13.0119 14.6872 13 14.7587 13H28.3117C28.7944 13 29.0328 13.602 28.6931 13.9596L26.4224 16.3138ZM26.4224 26.8391C26.321 26.9404 26.184 27 26.0409 27H12.5416C12.0648 27 11.8204 26.4159 12.1542 26.0702L14.3713 23.7697C14.419 23.7161 14.4845 23.6743 14.5501 23.6505C14.6156 23.6207 14.6872 23.6088 14.7587 23.6088H28.3117C28.7944 23.6088 29.0328 24.1988 28.6931 24.5445L26.4224 26.8391ZM26.4224 18.4653C26.321 18.364 26.184 18.3044 26.0409 18.3044H12.5416C12.0648 18.3044 11.8204 18.8885 12.1542 19.2341L14.3713 21.5347C14.419 21.5883 14.4845 21.6301 14.5501 21.6539C14.6156 21.6837 14.6872 21.6956 14.7587 21.6956H28.3117C28.7944 21.6956 29.0328 21.1056 28.6931 20.7599L26.4224 18.4653Z",
    fill: "url(#paint0_linear_1_44)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_44",
    x1: 13.0305,
    y1: 27.1747,
    x2: 27.7776,
    y2: 12.8172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF41E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10F2B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.62041b7d00d12619462f34b348125d6a.svg";
export { ForwardRef as ReactComponent };